// src/Api/endpoints.ts

// Define the base URLs for the API
//DEV
export const BASE_URL = process.env.REACT_APP_API_BASE_URL!;
export const SSO_BASE_URL = process.env.REACT_APP_API_SSO_BASE_URL!;
export const IMAGE_BASE_PATH = process.env.REACT_APP_IMAGE_BASE_PATH!;
export const ENVIRONMENT = process.env.REACT_APP_ENV!;
export const BASE_URL_WITHOUT_RESTRICTIONS = process.env.REACT_APP_BASE_URL_WITHOUT_RESTRICTIONS!;

//Production
// export const BASE_URL_WITHOUT_RESTRICTIONS = "https://api.boxchaos.com/api";
// export const BASE_URL = "https://api.boxchaos.com/aapi";
// export const IMAGE_BASE_PATH = "https://storage.googleapis.com/app-boxchaos-com-pub/";


// Export all endpoints for easy reference and maintainability
export const ApiEndpoints = {
  ME: "/me",
  ITEMS: "item",
  COUPONS: "coupons",  
  APP_USERS: "app-users",  
  ACTIVATE_DEACTIVATE_USE: "app-user/active-deactive",
  WITHDRAWAL_HISTORY: "crypto/withdraw-history",
  WITHDRAWAL_USER_HISTORY: "app-user/crypto-withdraw-history",
  BOXES: "box",
  FILE: "upload",
  COMPUTE_BOX: "box/compute",
  BOX_PREVIEW: "box/preview",
  LOGIN: "/login",
  BOXES_COUNT_FOR_ITEM: "/boxes_using_item",
  RENDER_VIDEO: "/render-video",
  VIP_BOXES: "vip_boxes",
  LOW_STOCK: "low_stock_notifier",
  GENERATE_BOX_VIDEOS: "generate-box-videos",
  RETIRED_BOXES: "retired_boxes_count",
  VERIFY_CAPTCHA: "verify-captcha",
};
